import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { queryClient } from './lib/query';
import { routeTree } from './routeTree.gen';

// Router-Instanz mit globalem Context (queryClient).
// HINWEIS: routeTree.gen.ts wird vom TanStack-Router-Vite-Plugin beim Start
// automatisch generiert. Tests/CI müssen `pnpm dev` (oder `pnpm build`)
// einmal laufen lassen oder das Plugin im Test-Setup aufrufen.
export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export function App(): JSX.Element {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
